export default __webpack_public_path__ + "static/media/Snd_C6.2d7fd975.mp3";